/** @format */

import axios from "axios";
import { Input } from "antd";
import { NavLink } from "react-router-dom";
import { useReactToPrint } from "react-to-print";
import { SearchOutlined } from "@ant-design/icons";
import React, { Fragment, useEffect, useMemo, useRef, useState } from "react";

import pdf from "../../../../icons/pdf.png";
import print from "../../../../icons/print.png";
import excel from "../../../../icons/excel.png";
import { header } from "../../../../components/api/Header";
import { monthName } from "../../../../components/functions/Month";
import LoadingCard from "../../../../components/loading/loadingCard";
import { ExcelPrint, Pdf } from "../../../../components/functions/Print";
import { getEnv } from "../../../../lib/env";
import { formatReservoirName } from "./helpers";

const TABLE_TITLE =
  "Respublika va respublikalararo suv omborlari ishlashi to'g'risida ma'lumot";
const EXPORT_TITLE = "Oylik hisobot";

const formatMonthlyExportDate = (value) => {
  if (!value) {
    return "";
  }

  return `${value.slice(0, 4)} ${monthName(value)}`;
};

function Table6({ date, setOmbor, setLoading, loading }) {
  const conponentPDF = useRef();
  const [report, setReport] = useState({
    days: [],
    rows: [],
  });
  const [searchText, setSearchText] = useState("");

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const res = await axios.get(
          `${getEnv("REACT_APP_BASE_URL")}/v1/republik/suvombor/oylik-kunlik-hisobot?date=${date}`,
          header()
        );
        setReport(res.data || {});
      } catch (e) {
        console.log("Xato", e);
        alert("Bazaga bog'lanishda xato");
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [date, setLoading]);

  const days = useMemo(() => {
    const source = Array.isArray(report.days) ? report.days : [];

    return source.map((day) => day.day);
  }, [report.days]);

  const visibleRows = useMemo(() => {
    const text = searchText.trim().toUpperCase();
    const rows = Array.isArray(report.rows) ? report.rows : [];

    if (!text) {
      return rows;
    }

    return rows.filter((row) => {
      if (row.type !== "data") {
        return false;
      }

      return String(row.name || "").toUpperCase().includes(text);
    });
  }, [report.rows, searchText]);

  const generatePDF = useReactToPrint({
    content: () => conponentPDF.current,
    documentTitle: EXPORT_TITLE,
    onAfterPrint: () => alert("Data saved in PDF"),
  });

  const totalColumns = days.length + 3;
  const exportDate = formatMonthlyExportDate(date);

  return (
    <>
      <div className='table-content-top'>
        <div className='table-top-left'>
          <Input
            prefix={<SearchOutlined className='site-form-item-icon' />}
            placeholder='Search'
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
          />
        </div>

        <ul className='table-top-right'>
          <li>
            <button className='btn p-0' onClick={() => generatePDF()}>
              <img src={print} alt='404' />
            </button>
          </li>

          <li>
            <button onClick={() => Pdf("so6", true, exportDate)} className='btn p-0'>
              <img src={pdf} alt='404' />
            </button>
          </li>

          <li>
            <button
              className='btn p-0'
              onClick={() =>
                ExcelPrint(EXPORT_TITLE, "Sheet 1", "so6", exportDate)
              }>
              <img src={excel} alt='404' />
            </button>
          </li>
        </ul>
      </div>

      {loading ? (
        <LoadingCard loading={loading} heightSize='80vh' />
      ) : (
        <div className='table-responsive tableFixHead' id='tableFlexible'>
          <div ref={conponentPDF} style={{ width: "100%" }}>
            <table
              className='table table-bordered table-style suv-reservoir-table'
              id='so6'>
              <thead>
                <tr>
                  <th colSpan={totalColumns} scope='col'>
                    {TABLE_TITLE}
                  </th>
                </tr>

                <tr>
                  <th rowSpan={2} scope='col'>
                    Suv ombor nomi
                  </th>
                  <th colSpan={2} rowSpan={2} scope='col'>
                    Birligi
                  </th>
                  {days.map((day) => (
                    <th key={day} rowSpan={2} scope='col'>
                      {day}
                    </th>
                  ))}
                </tr>
              </thead>

              <tbody>
                {visibleRows.map((row, index) => {
                  if (row.type === "group") {
                    return (
                      <tr className='table-one-row j-tr' key={index}>
                        <td colSpan={totalColumns}>{row.name}</td>
                      </tr>
                    );
                  }

                  return (
                    <Fragment key={index}>
                      <tr className='data-tr'>
                        <td className='text-start fix-with' rowSpan={3}>
                          <NavLink
                            style={{ color: "#222" }}
                            to={"/suvomborlari/" + row.id}
                            onClick={() =>
                              setOmbor({
                                nomi: row.name,
                                location: [row.lat, row.lan],
                              })
                            }>
                            {formatReservoirName(row.name)}
                          </NavLink>
                        </td>
                        <td className='text-center'>Kelishi</td>
                        <td className='text-center'>
                          m<sup>3</sup>/sek
                        </td>
                        {renderValues(row.inflow)}
                      </tr>
                      <tr className='data-tr'>
                        <td className='text-center'>Hajmi</td>
                        <td className='text-center'>
                          mln m<sup>3</sup>
                        </td>
                        {renderValues(row.volume)}
                      </tr>
                      <tr className='data-tr'>
                        <td className='text-center'>Chiqishi</td>
                        <td className='text-center'>
                          m<sup>3</sup>/sek
                        </td>
                        {renderValues(row.outflow)}
                      </tr>
                    </Fragment>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </>
  );
}

export default Table6;

const renderValues = (values = []) =>
  values.map((value, index) => <td key={index}>{filteredValue(value)}</td>);

const filteredValue = (value) => {
  if (value === null || value === undefined || value === "" || value === "undefined") {
    return "-";
  }

  const number = parseFloat(value);
  if (Number.isNaN(number)) {
    return "-";
  }

  const rounded = Math.round((number + Number.EPSILON) * 100) / 100;

  return rounded % 1 === 0 ? Math.floor(rounded) : rounded;
};
